/*
  Restock ETA (Hogg-owned; api-tools/CLAUDE-RESTOCK-ETA.md).
  Keeps #RestockEta-<section id> (snippets/restock-eta.liquid) in step with
  the selected variant. product-info.js already fetches the new variant's
  section HTML on every option change and publishes it on variantChange;
  this copies the ETA block out of that HTML. No extra request, and
  product-info.js stays untouched so Dawn updates stay clean.
*/
(function () {
  if (window.hoggRestockEtaLoaded) return; // Quick Add can inject this script more than once
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  window.hoggRestockEtaLoaded = true;

  // Shopper's local date as YYYYMMDD, same shape as data-eta-key.
  function todayKey() {
    var d = new Date();
    return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  }

  // A cached page can carry a stale server-side "today"; re-check here.
  function hideIfPast(el) {
    var eta = parseInt(el.dataset.etaKey, 10);
    if (eta && eta < todayKey()) el.hidden = true;
  }

  function etaFor(info) {
    return info && info.querySelector('#RestockEta-' + info.dataset.section);
  }

  document.querySelectorAll('.restock-eta').forEach(hideIfPast);

  // Hide as soon as an option is clicked. Covers option combinations with no
  // variant, where product-info.js never publishes variantChange.
  if (PUB_SUB_EVENTS.optionValueSelectionChange) {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
      var target = event.data && event.data.target;
      var el = etaFor(target && target.closest('product-info'));
      if (el) el.hidden = true;
    });
  } else {
    // Older Dawn (rotation themes) has no optionValueSelectionChange; hide on the
    // picker's change event instead. variantChange re-shows it once the fetch lands.
    document.addEventListener('change', function (e) {
      var picker = e.target.closest && e.target.closest('variant-radios, variant-selects');
      var el = etaFor(picker && picker.closest('product-info'));
      if (el) el.hidden = true;
    });
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var sectionId = event.data.sectionId;
    var source = event.data.html.getElementById('RestockEta-' + sectionId);
    document.querySelectorAll('product-info').forEach(function (info) {
      if ((info.dataset.originalSection || info.dataset.section) !== sectionId) return;
      var el = etaFor(info);
      if (!el) return;
      el.innerHTML = source ? source.innerHTML : '';
      el.dataset.etaKey = (source && source.dataset.etaKey) || '';
      el.hidden = !source || source.hidden;
      hideIfPast(el);
    });
  });
})();
